export const regionSelector = {
  title: "Select a region to sign in",
  us: "United States",
  usSubtitle: "Sign in to US",
  ca: "Canada",
  caSubtitle: "Sign in to CA",
} as const;
